import axios from 'axios'

export const BASE_URL = 'https://be.sea-pengendalian.mtg.co.id/'

const api = axios.create({
  baseURL: BASE_URL,
})

api.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem('userPengendalian') || '{}')

  config.headers = config.headers || {}
  if (user.accessToken) {
    config.headers.Authorization = `Bearer ${user.accessToken}`
  }

  return config
})

export default api
